/* eslint-disable
    no-unused-vars,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
const deps = [require('vendor/pubnub').name];

module.exports = angular
  .module('bench.data.actions.pubnub', deps)

  .factory('PubnubActions', ($rootScope, Pubnub) => ({
    categorizationRequested({ clientId }) {
      return `bl.pubnub.categorizationRequested.${clientId}`;
    },
    messageCreated({ clientId }) {
      return `bl.pubnub.messageCreated.${clientId}`;
    },
    messageEdited({ clientId }) {
      return `bl.pubnub.messageEdited.${clientId}`;
    },
    presence({ clientId }) {
      return `bl.pubnub.presence.${clientId}`;
    },
    event(name) {
      return `bl.pubnub.${name}`;
    },
  }));
